var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveDemo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.94678 2.14844H12.4468V5.64844",
    stroke: "#2563EB",
    strokeOpacity: 0.3,
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03003 8.5651L12.4467 2.14844",
    stroke: "#2563EB",
    strokeOpacity: 0.3,
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6968 7.98177V11.4818C10.6968 11.7912 10.5739 12.0879 10.3551 12.3067C10.1363 12.5255 9.83953 12.6484 9.53011 12.6484H3.11344C2.80402 12.6484 2.50728 12.5255 2.28849 12.3067C2.06969 12.0879 1.94678 11.7912 1.94678 11.4818V5.0651C1.94678 4.75568 2.06969 4.45894 2.28849 4.24015C2.50728 4.02135 2.80402 3.89844 3.11344 3.89844H6.61344",
    stroke: "#2563EB",
    strokeOpacity: 0.3,
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveDemo);
export default __webpack_public_path__ + "static/media/live_demo.0e4cc53a615636236e853b78129a4e87.svg";
export { ForwardRef as ReactComponent };